import React, { useContext } from 'preact/compat';
import { EmailFormProps } from './types';

export const EmailFormContext = React.createContext<EmailFormProps | null>(null);

export function useEmailFormContext() {
    const context = useContext(EmailFormContext);

    if (context === null) {
        throw new Error('The useSelfServiceFormContext() must be used inside a SelfServiceFormContext.Provider component.');
    }

    return context;
}
